import Axios from "../config/Axios";


export const ApiCrearDiaInactivo = async (data) => {
    try {
      const result = await Axios.post(`/POSTcreateDiaInactivo`, data);
      return result.data;
    } catch (e) {
      return [
        {
          sms: "err",
          data: [],
          mensaje: e,
        },
      ];
    }
  };
  
export const ApiEditarDiaInactivo= async (data) => {
    try {
        const result = await Axios.post(`/POSTeditDiaInactivo`, data);
        return result.data;
    } catch (e) {
        return [
        {
            sms: "err",
            data: [],
            mensaje: e,
        },
        ];
    }
};

export const ApiActivarDesactivarDiaInactivo = async (data) => {
    try {
        const result = await Axios.post(`/POSTtoggleEstadoDiaInactivo`, data);
        return result.data;
    } catch (e) {
        return [
        {
            sms: "err",
            data: [],
            mensaje: e,
        },
        ];
    }
};

export const ApiDeleteDiaInactivo = async (pre_dia_inactivo_id) => {
    try {
        const result = await Axios.post(`/POSTdeleteDiaInactivo`, pre_dia_inactivo_id);
        return result.data;
    } catch (e) {
        return [
        {
            sms: "err",
            data: [],
            mensaje: e,
        },
        ];
    }
};


export const ApiGetAllDiaInactivos = async (data) => {
    try {
        const result = await Axios.get(`/GETallDiasInactivos`);
        return result.data;
    } catch (e) {
        return [
        {
            sms: "err",
            data: [],
            mensaje: e,
        },
        ];
    }
};


export const ApiGetDataDiaInactivo = async (pre_dia_inactivo_id) => {
try {
    const result = await Axios.get(`/GETdataDiaInactivo/${pre_dia_inactivo_id}`);
    return result.data;
} catch (e) {
    return [
    {
        sms: "err",
        data: [],
        mensaje: e,
    },
    ];
}
};